import { setUploadCategory, useUploadCategory } from "@/lib/uploadCategory";
import { useI18n } from "@/i18n/I18nContext";
import { useSpace } from "@/context/SpaceContext";

const OPTIONS = ["auto", "app", "minisite"];

// Official uploads (single, batch, link, Drive, share): category of the app created from the APK.
export const CategoryPick = () => {
  const { t } = useI18n();
  const { isDev } = useSpace();
  const value = useUploadCategory();
  const opts = isDev ? OPTIONS.slice(1) : OPTIONS;  // developers declare it themselves (no automatic choice)
  return (
    <fieldset className="min-w-0 rounded-2xl border border-[rgba(245,197,66,0.18)] bg-black/30 p-3" data-testid="upload-category-pick">
      <legend className="px-1 text-xs uppercase tracking-wider text-neutral-400">{t("mini.uploadCategory")}</legend>
      <div className="flex flex-wrap gap-2">
        {opts.map((o) => (
          <button key={o} type="button" aria-pressed={value === o} onClick={() => setUploadCategory(o)}
            className={`max-w-full whitespace-normal break-words rounded-full border px-3 py-1.5 text-start text-xs font-semibold transition-colors ${value === o ? "border-[var(--gold)] bg-[var(--gold)] text-black" : "border-[rgba(245,197,66,0.3)] text-neutral-200 hover:border-[var(--gold)]"}`}
            data-testid={`upload-category-${o}`}>
            {t(`mini.cat.${o}`)}
          </button>
        ))}
      </div>
      {isDev && <p className="mt-2 break-words text-[0.7rem] text-neutral-500" data-testid="upload-category-dev-hint">{t("plat.devUploadHint")}</p>}
      {!isDev && value === "auto" && <p className="mt-2 break-words text-[0.7rem] text-neutral-500" data-testid="upload-category-hint">{t("mini.autoHint")}</p>}
    </fieldset>
  );
};
